import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import type { PlanMeasures } from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";

export type AlternativeTransportPlansResponse = {
  infrastructure: PlanMeasures;
  train: PlanMeasures;
};

export function useAlternativeTransportPlans() {
  const alternativeTransportPlansResponse = useQuery({
    queryKey: ["alternativeTransportPlans"],
    queryFn: () =>
      axiosClient.get<AlternativeTransportPlansResponse>(
        `${getBackendUrl()}/alternative-transport-planning/plans`,
      ),
    refetchInterval: 60 * 1000, // Every minute
    retry: false,
  });

  return alternativeTransportPlansResponse;
}
